import { render } from "./OtsButton.vue?vue&type=template&id=fe8917f2&scoped=true&ts=true"
import script from "./OtsButton.vue?vue&type=script&lang=ts"
export * from "./OtsButton.vue?vue&type=script&lang=ts"

import "./OtsButton.vue?vue&type=style&index=0&id=fe8917f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8917f2"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBadge,QIcon,QTooltip,QSpinnerFacebook});
